var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-page-edit',{attrs:{"title":_vm.title,"nameRoleEntity":_vm.nameRoleEntity,"paramsSend":{
        entity: _vm.nameEnity
      },"apiNameGet":_vm.apiNameGet,"apiNameCreate":_vm.apiNameCreate,"apiNameUpdate":_vm.apiNameUpdate,"routeNameShow":"EntityDynamicShow","routeNameCreate":"CreatePageDynamic","backUrl":'/entity/' + _vm.$route.params.entity}})
}
var staticRenderFns = []

export { render, staticRenderFns }